<script setup>
import {ref, computed, watch, watchEffect} from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import axios from "axios";
const store = useStore();
const productId = computed(() => store.getters.getProductId);
const props = defineProps(['title', 'list', 'categories', 'titleClass']);
const router = useRouter();
const activeCategory = ref(0);
let questionList = ref([]);
const getQuestionList = () => {
  if (props.categories && props.categories.length > 0) {
    const categoryId = props.categories[activeCategory.value].id;
    const questionQueryData = {
      plateMarrow: 1,
      categoryId: categoryId,
      productId: productId.value,
      page: 0,
      size: 100,
    };
    axios.get('/question', {params: questionQueryData}).then(res => {
      if (res.data && res.data.content) {
        questionList.value = res.data.content;
        console.log('questions of category', questionList.value);
      } else {
        console.error('Invalid response data:', res.data);
      }
    }).catch(err => {
      console.log(err);
    });
  }
};
watchEffect(() => {
  if (props.list) {
    questionList.value = props.list;
  }
});
if (props.categories) {
  watch(() => props.categories, () => {
    getQuestionList();
  });
}
const changeCategory = (index) => {
  activeCategory.value = index;
  getQuestionList();
}
const goToDetail = (item) => {
  router.push({
    path: '/detail',
    query: item,
  });
};
</script>

<template>
  <div class="list-box">
    <div :class="`title-box-${props.titleClass}`">
      {{title}}
    </div>
    <div class="category-box" v-if="categories">
      <div v-for="(item, index) in categories" @click="changeCategory(index)" :class="{ category: true, active: index === activeCategory }">{{item.name}}</div>
    </div>
    <div class="content-box">
      <div v-for="item in questionList" :key="item.id" @click="goToDetail(item)">
        {{item.content}}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/entries/index/index.scss';
@mixin title {
  font-size: 24 * $px;
  line-height: 48 * $px;
  height: 48 * $px;
  padding: 28 * $px 36 * $px;
  border-radius: 14 * $px;
}
.list-box {
  margin: 24 * $px;
  background: #fff;
  border-radius: 14 * $px;
  .title-box-normal {
    @include title;
    font-weight: bold;
  }
  .title-box-weak {
    @include title;
    color: rgba(136, 136, 136, 1);
  }
  .title-box-first {
    @include title;
    font-weight: bold;
    background: linear-gradient(180deg, rgba(109, 136, 255, 0.2) -50%, rgba(255, 255, 255, 0.2) 100%);
  }
  .category-box {
    margin: 24 * $px 0;
    padding: 0 28 * $px;
    display: flex;
    justify-content: space-between;
    .category {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 151.25 * $px;
      height: 66 * $px;
      font-size: 28 * $px;
      text-align: center;
      border: 0;
      border-radius: 101 * $px;
      background: rgba(247, 247, 249, 1);
      color: rgba(102, 102, 102, 1);
      gap: 10 * $px;
      white-space: nowrap;
      overflow: hidden;
      &.active {
        background: rgba(231, 235, 255, 1);
        color: rgba(75, 106, 255, 1);
        box-shadow: none;
        outline: none;
        font-weight: bold;
      }
    }
  }
  .content-box {
    font-size: 28 * $px;
    line-height: 42 * $px;
    position: relative;
    margin: 0;
    padding-inline-start: 36 * $px;
    padding-bottom: 24 * $px;
    div {
      list-style-type: none;
      height: 74 * $px;
      line-height: 74 * $px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 87 * $px;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%); // 垂直居中
        right: 0; // 调整图标与输入框边缘的距离
        width: 87 * $px;
        height: 74 * $px;
        background-image: url('../assets/right.png');
        background-size: cover; // 确保图标大小正确
      }
    }
  }
}
</style>
